/*
 * rp-drawer-unlock.js — Fix del "congelamiento" tras cerrar el carrito/drawer con
 * el botón ATRÁS del teléfono (o al volver por bfcache), en TODA la tienda.
 *
 * CAUSA RAÍZ (tema Horizon):
 *   - Al abrir el cart-drawer en móvil (<990px) el tema hace showModal() y aplica
 *     lockScroll() → pone el atributo [scroll-lock] en <html>. base.css hace
 *     `html[scroll-lock], html[scroll-lock] .page-wrapper { overflow:hidden }`,
 *     así que con ese atributo la página NO scrollea (queda "congelada").
 *   - El tema SOLO llama unlockScroll() dentro de su propio close()/closeDialog()
 *     (la "x", Escape-vía-JS o click-fuera). Cuando el <dialog> modal se cierra de
 *     forma NATIVA —el botón atrás de Android dispara un "close request" (close
 *     watcher) que cierra el dialog, o al restaurar desde bfcache— ese camino de
 *     limpieza NO corre → [scroll-lock] se queda pegado en <html> → la página del
 *     producto queda congelada. (Comprobado: el cierre nativo del <dialog> ni
 *     siquiera emite el evento `close`, así que NO se puede depender de ese evento.)
 *
 * FIX (site-wide, a prueba de futuro; sin tocar el core del tema):
 *   Un MutationObserver observa el atributo [open] de cualquier <dialog>. Cuando un
 *   <dialog> pasa a cerrado mientras su <theme-drawer> aún figura [open] (= cierre
 *   nativo que se saltó la limpieza), ejecutamos el close() público del componente
 *   para correr TODA su limpieza (unlockScroll, quitar [open], restaurar foco, quitar
 *   la clase de "squeeze"). Luego quitamos cualquier [scroll-lock] residual si ya no
 *   hay ningún dialog realmente abierto. Además reconciliamos en pageshow (bfcache),
 *   popstate y al volver a la pestaña.
 *
 * Idempotente y SIN regresiones:
 *   - Cierre normal por "x": el tema quita [open] y llama unlockScroll ANTES de
 *     cerrar el <dialog>, así que aquí el drawer ya no matchea [open] y reconcile
 *     es no-op. No hay doble cierre.
 *   - Cambios de modo/traer-al-frente del tema (close()+showModal() sincrónicos):
 *     el observer se agrupa y leemos el estado VIVO `dialog.open` (ya reabierto) →
 *     no interferimos.
 *   - Acordeones <details open>: se ignoran (filtro tagName === 'DIALOG').
 */
(function () {
  if (window.__rpDrawerUnlockBound) return;
  window.__rpDrawerUnlockBound = true;

  var docEl = document.documentElement;

  /**
   * @returns {boolean} ¿Algo que legítimamente bloquea el scroll sigue abierto?
   * El tema pone [scroll-lock] en <html> por dos vías:
   *   - showModal() de un <dialog> (carrito, búsqueda, quick-add…), y
   *   - un <details scroll-lock> abierto (el MENÚ móvil), vía el handler global
   *     de `toggle` en dialog.js.
   * No debemos quitar el lock si CUALQUIERA de esos sigue abierto de verdad.
   */
  function scrollLockStillNeeded() {
    if (document.querySelector('dialog[open]')) return true;
    var details = document.querySelectorAll('details[scroll-lock]');
    for (var i = 0; i < details.length; i++) {
      if (details[i].open) return true;
    }
    return false;
  }

  /**
   * Sincroniza los drawers que quedaron [open] con su <dialog> ya cerrado (cierre
   * nativo) y limpia cualquier scroll-lock/squeeze residual. Seguro e idempotente.
   */
  function reconcile() {
    // 1) Drawer cuyo <dialog> se cerró por debajo (botón atrás / close-request).
    var openDrawers = document.querySelectorAll('theme-drawer[open]');
    for (var i = 0; i < openDrawers.length; i++) {
      var drawer = openDrawers[i];
      var dialog = drawer.querySelector('dialog');
      if (dialog && !dialog.open) {
        if (typeof drawer.close === 'function') {
          try {
            // close() es async; tragamos cualquier rechazo (p.ej. una animación
            // abortada) para no generar "unhandled promise rejection".
            var p = drawer.close();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } catch (e) {
            drawer.removeAttribute('open');
          }
        } else {
          drawer.removeAttribute('open');
        }
      }
    }

    // 2) Quitar el scroll-lock atascado si ya no hay nada legítimamente abierto
    // (ni <dialog> modal ni <details scroll-lock> como el menú móvil).
    if (docEl.hasAttribute('scroll-lock') && !scrollLockStillNeeded()) {
      docEl.removeAttribute('scroll-lock');
    }

    // 3) Quitar la clase de "squeeze" si ya no hay ningún drawer abierto.
    if (!document.querySelector('theme-drawer[open]')) {
      var pw = document.querySelector('.page-wrapper');
      if (pw) pw.classList.remove('page-wrapper--drawer-open');
    }
  }

  // MutationObserver: detecta de forma FIABLE que un <dialog> se cerró, sin importar
  // el mecanismo (close-request nativo, close watcher, programático, bfcache). Se
  // observa el atributo [open] en todo el árbol porque el carrito se re-renderiza.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      // Leemos el estado VIVO `.open` (no el del registro) para no reaccionar a un
      // close()+showModal() sincrónico del propio tema (traer-al-frente/cambio de modo).
      if (target && target.tagName === 'DIALOG' && !target.open) {
        reconcile();
        return;
      }
    }
  });
  observer.observe(docEl, { subtree: true, attributes: true, attributeFilter: ['open'] });

  // Restauración por bfcache / navegación hacia atrás: des-congelar al mostrar.
  window.addEventListener('pageshow', function () {
    reconcile();
    // Repetir tras un frame por si el restore del propio tema re-aplica el lock.
    requestAnimationFrame(reconcile);
  });

  window.addEventListener('popstate', function () {
    requestAnimationFrame(reconcile);
  });

  // Salvavidas: si al volver a la pestaña quedó un lock sin dialog abierto.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') reconcile();
  });
})();
